import classnames from "classnames";

import { DEFAULT_TAKE_COUNT } from "@/api/requests/getMenuItems";
import { MenuItem } from "@/custom-types/MenuItem";
import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import { dispensaryHref } from "@/utils/dispensaryUrls";

import Carousel from "@/components/botanic/Carousel";
import MenuCard from "@/components/Dispensary/MenuCard";

const StaffPicksCarousel: React.FC<{
  cardsPerSlide?: number;
  className?: string;
  dispensaryId: number;
  dispensarySlug: string;
  maxCardCount?: number;
  dispensaryRetailType: string;
  staffPicks: MenuItem[];
}> = ({
  cardsPerSlide = 4,
  className,
  dispensaryId,
  dispensarySlug,
  maxCardCount = DEFAULT_TAKE_COUNT,
  dispensaryRetailType,
  staffPicks,
}) => {
  const countryCode = useDomainCountryCode();

  if (!staffPicks.length) {
    return null;
  }

  return (
    <div data-testid="staff-picks-carousel" className={classnames(className)}>
      <Carousel
        cardsPerSlide={cardsPerSlide}
        title={
          <h2
            className="heading--m font-extrabold"
            data-testid="section-header"
          >
            Staff favorites
          </h2>
        }
        seeMoreHref={dispensaryHref({
          additionalPath: `/menu?whats_hot[]=is_staff_pick`,
          countryCode,
          retailType: dispensaryRetailType,
          slug: dispensarySlug,
        })}
      >
        {staffPicks.slice(0, maxCardCount).map((item: MenuItem) => (
          <MenuCard
            dispensaryId={dispensaryId}
            displayStaffPick={true}
            key={item.id}
            menuItem={item}
          />
        ))}
      </Carousel>
    </div>
  );
};

export default StaffPicksCarousel;
